import { DatePicker, Form, Select } from "antd";
import moment from "moment";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Divider } from "primereact/divider";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import React, { useRef, useState } from "react";
import "./style.scss";
import {
    usersStatistic
} from "../../../apis/ProjectInvoiceApi";

import { getUsersByRoles } from "../../../apis/SettingApis";

import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { useEffect } from "react";

const Statistic = (props) => {
    const [apiLoading, setApiLoading] = useState(false);
    const [form] = Form.useForm();
    const toast = useRef(null);
    const [uniqueUsers, setUniqueUsers] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const fetchUsers = () => {
        setApiLoading(true);
        getUsersByRoles("all", -1)
            .then((res) => {
                if (res.status === 200) {
                    let users = [...new Set(res.data.map(item => item.username))];
                    users.sort();
                    users = users.map(user => ({ label: user, value: user }));
                    users.unshift({ label: 'All Members', value: 'all' });
                    setUniqueUsers(users);
                    setApiLoading(false);
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: res.response.data,
                        life: 3000,
                    });
                    setApiLoading(false);
                }
            })
            .catch((e) => {
                toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const submit = () => {
        form.validateFields().then((values) => {
            props.setLoading(true);
            let newValues = {
                startDate: `${moment(values.startDate).format("DD-MM-yyyy hh:mm a")}`,
                endDate: `${moment(values.endDate).format("DD-MM-yyyy hh:mm a")}`,
                users: values.users ? values.users?.join(",") : "all",
            };
            usersStatistic(newValues)
                .then((res) => {
                    if (res.status === 200) {
                        console.log("statistic data: ", JSON.stringify(res));
                        let data = transformData(res.data);
                        setFilteredData(data);
                        props.setLoading(false);
                    } else {
                        toast.current.show({
                            severity: "error",
                            summary: "Status",
                            detail: res.response.data,
                            life: 3000,
                        });
                        props.setLoading(false);
                    }
                })
                .catch((e) => {
                    toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: e,
                        life: 3000,
                    });
                    props.setLoading(false);
                });
        });
    };

    const getChildClass = (index) => {
        switch (index) {
            case 0: return "bg-green";
            case 1: return "bg-orange";
            case 2: return "bg-yellow";
            case 3: return "bg-blue";
            default: return ''
        }
    }

    /**
     * Transform from list data to list data can use in data table
     * @param {*} inputData 
     * @returns 
     */
    const transformData = (inputData) => {
        inputData.forEach((item, index) => {
            item.projectsTooLateAsEmployee = item.projectsAsEmployee - item.projectsOnTimeAsEmployee;
            item.percentageOnTimeAsEmployee = item.projectsAsEmployee > 0 ? `${((item.projectsOnTimeAsEmployee / item.projectsAsEmployee) * 100).toFixed(0)}%` : "0%";
            item.projectsTooLateAsQualityChecker = item.projectsAsQualityChecker - item.projectsOnTimeAsQualityChecker;
            item.percentageOnTimeAsQualityChecker = item.projectsAsQualityChecker > 0 ? `${((item.projectsOnTimeAsQualityChecker / item.projectsAsQualityChecker) * 100).toFixed(0)}%` : "0%";
            item.projectsTooLateAsManager = item.projectsAsManager - item.projectsOnTimeAsManager;
            item.percentageOnTimeAsManager = item.projectsAsManager > 0 ? `${((item.projectsOnTimeAsManager / item.projectsAsManager) * 100).toFixed(0)}%` : "0%";
            item.className = getChildClass(index);
        });

        console.log("transformed data: ", JSON.stringify(inputData));
        return inputData;
    }


    const headerGroup = <ColumnGroup>
        <Row>
            <Column header="Team member" rowSpan={2} style={{ minWidth:"120px" }} />
            <Column header="Total" colSpan={3} />
            <Column header="Num Projects On Time" colSpan={3} />
            <Column header="Num Projects Too late" colSpan={3} />
            <Column header="Percentage on time" colSpan={3} />
        </Row>

        <Row>
            <Column header="Contractor" />
            <Column header="Quality Checker" />
            <Column header="Final Checker" />

            <Column header="Contractor" />
            <Column header="Quality Checker" />
            <Column header="Final Checker" />

            <Column header="Contractor" />
            <Column header="Quality Checker" />
            <Column header="Final Checker" />

            <Column header="Contractor" />
            <Column header="Quality Checker" />
            <Column header="Final Checker" />
        </Row>
    </ColumnGroup>;

    const getRowClassName = (rowData) => {
        return rowData.className;
    };
    return (
        <React.Fragment>
            <div>
                <Toast ref={toast} />
                <div className="card" style={{ height: "72vh" }}>
                    <div className="grid" style={{ height: "70vh" }}>
                        <div className="col-3 flex align-items-center justify-content-center">
                            <div>
                                <Form form={form}
                                    size="middle"
                                    className="custom-form-design"
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 14 }}
                                    onFinish={submit}
                                >
                                    <Form.Item
                                        name="startDate"
                                        label="Start Date"
                                        required
                                        rules={[
                                            {
                                                required: true,
                                                message: "Start Date is required.",
                                            },
                                        ]}
                                    >
                                        <DatePicker />
                                    </Form.Item>
                                    <Form.Item
                                        name="endDate"
                                        label="End Date"
                                        required
                                        rules={[
                                            {
                                                required: true,
                                                message: "End Date is required.",
                                            },
                                        ]}
                                    >
                                        <DatePicker />
                                    </Form.Item>
                                    {uniqueUsers.length > 0 ?
                                        (<Form.Item name="users" label={uniqueUsers.length > 0 ? "Select member" : ""}>
                                            <Select
                                                defaultValue={"all"}
                                                isClearable
                                                style={{ width: "150px" }}
                                                options={uniqueUsers}
                                                mode={"multiple"}
                                            >
                                            </Select>
                                        </Form.Item>)
                                        : ("")
                                    }
                                    <Form.Item style={{ alignItems: "center" }}>
                                        <Button type="submit" style={{ float: "right" }}>
                                            Generate
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                        <div className="col-1">
                            <Divider layout="vertical"></Divider>
                        </div>
                        <div className="col-8">
                            <Toolbar
                                className="mb-4"
                                left={() => {
                                    return (
                                        <React.Fragment>
                                            <div>
                                                <h3 className="m-0">User Statistic Data</h3>
                                            </div>
                                        </React.Fragment>
                                    );
                                }}
                            ></Toolbar>
                            <div className="treetable-responsive-demo">
                                <DataTable
                                    value={filteredData}
                                    dataKey="id"
                                    responsiveLayout="scroll"
                                    selectionMode="single"
                                    className="overflow-y-auto"
                                    style={{ maxHeight: "50vh" }}
                                    headerColumnGroup={headerGroup}
                                    size={"small"}
                                    rowClassName={getRowClassName}
                                >
                                    <Column field="user" className="header-user">
                                    </Column>

                                    <Column field="projectsAsEmployee" >
                                    </Column>
                                    <Column field="projectsAsQualityChecker" >
                                    </Column>
                                    <Column field="projectsAsManager" >
                                    </Column>

                                    <Column field="projectsOnTimeAsEmployee" >
                                    </Column>
                                    <Column field="projectsOnTimeAsQualityChecker" >
                                    </Column>
                                    <Column field="projectsOnTimeAsManager" >
                                    </Column>

                                    <Column field="projectsTooLateAsEmployee" >
                                    </Column>
                                    <Column field="projectsTooLateAsQualityChecker" >
                                    </Column>
                                    <Column field="projectsTooLateAsManager" >
                                    </Column>

                                    <Column field="percentageOnTimeAsEmployee" >
                                    </Column>
                                    <Column field="percentageOnTimeAsQualityChecker" >
                                    </Column>
                                    <Column field="percentageOnTimeAsManager" >
                                    </Column>
                                </DataTable>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Statistic
